// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Card__Wrapper_1xFgs","Head":"Card__Head_3_TgX"};